import $ from 'jquery';
import aos from 'aos/dist/aos';


export default () => {
    // if($(window).width() <= 768) {
        aos.init({
            startEvent: 'load'
        });
    // }
};



// WEBPACK FOOTER //
// ./scripts/libs/aos.js